import { Component, inject } from '@angular/core';
import { HealthStatisticCardComponent } from '../health-statistic-card/health-statistic-card.component';
import { RouterModule } from '@angular/router';
import { APP_ROUTES } from '../../app.routes.definition';
import dayjs from 'dayjs';
import {HealthDataPeriod, HealthDataType, HealthDataValue} from '../../models/health.models';
import { HealthDataService } from '../../services/health-data.service';
import { LogService } from '../../services/log.service';
import {dataType} from "terra-api/lib/esm/API/Data";

@Component({
    selector: 'health-statistic-respiratory-rate-card',
    standalone: true,
    imports: [RouterModule, HealthStatisticCardComponent],
    templateUrl: './health-statistic-respiratory-rate-card.component.html',
})
export class HealthStatisticRespiratoryRateCardComponent {
    #healthDataService = inject(HealthDataService);
    #logService = inject(LogService);

    title = 'Frequenza Respiratoria';
    healthTypePath = APP_ROUTES.MONITOR_BODY_RESPIRATORY_RATE(false);
    dataType = HealthDataType.RESPIRATORY_RATE;
    lastMonitoredData = '';
    dateFrom = dayjs(new Date());
    period: HealthDataPeriod = HealthDataPeriod.dayLastValue;
    payloadTypes: dataType[] = ['sleep'];
    isLoading = true;

    ngOnInit(): void {
        this.#healthDataService
            .fetchHealthUserData(
                this.dataType,
                {
                    period: this.period,
                    dateFrom: this.dateFrom.format('YYYY-MM-DD'),
                    payloadTypes: this.payloadTypes
                }
            )
            .subscribe({
                next: (response: HealthDataValue[]) => {
                    if (response.length > 0) {
                        const lastValue = response[response.length - 1];
                        const values = response.map((entry) => entry.value);
                        const filteredValues = values.filter(
                            (value) => value === null
                        );

                        if (filteredValues.length > 0) {
                            this.lastMonitoredData = '-';
                        } else {
                            this.lastMonitoredData = lastValue.value
                                .toFixed(0)
                                .toString();
                        }
                    }
                    this.isLoading = false;
                },
                error: (error) => {
                    this.#logService.error(error);
                    this.isLoading = false;
                },
            });
    }
}
